import React from 'react';
import { X } from 'lucide-react';
import {
  isMobileWeb,
  isBannerDismissed,
  dismissBanner,
  getStoreUrl,
  buildAppDeepLink,
} from '@/lib/appPromo';

/**
 * Slim, dismissible "get the app" bar for mobile-web users. Renders nothing on
 * desktop or once dismissed (snoozed for a week). Sits sticky at the top of the
 * dashboard content area so it stays visible while scrolling.
 */
export const DownloadAppBanner: React.FC = () => {
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    if (isMobileWeb() && !isBannerDismissed()) {
      setShow(true);
    }
  }, []);

  if (!show) return null;

  const handleOpen = () => {
    // Try the app first; if it isn't installed the store link is one tap away.
    window.location.href = buildAppDeepLink('jobs');
    setTimeout(() => {
      window.location.href = getStoreUrl();
    }, 1200);
  };

  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation();
    dismissBanner();
    setShow(false);
  };

  return (
    <div className="sticky top-0 z-30 flex items-center gap-3 px-3 py-2 bg-primary text-primary-foreground shadow-sm">
      <button
        onClick={handleDismiss}
        className="shrink-0 p-1 rounded-full hover:bg-white/20 transition-colors"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>

      <img
        src="https://vftrlkabvhbpieuoqhzs.supabase.co/storage/v1/object/public/logo/fmf-mobile.png"
        alt="Find My Filmmaker"
        className="h-8 w-8 rounded-lg shrink-0"
      />

      <div className="flex-1 min-w-0 leading-tight">
        <p className="text-sm font-semibold truncate">Find My Filmmaker app</p>
        <p className="text-[11px] opacity-90 truncate">Faster jobs & instant notifications</p>
      </div>

      <button
        onClick={handleOpen}
        className="shrink-0 px-4 py-1.5 rounded-full bg-white text-primary text-sm font-semibold hover:bg-white/90 transition-colors"
      >
        Get
      </button>
    </div>
  );
};

export default DownloadAppBanner;
